import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';
import {QueryValue} from "../../../../../services/model/queryValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";
import {FilterValue} from "../../../../../services/model/filterValue";

@Component({
    selector: 'efast-filter-welfare',
    templateUrl: 'efast-filter-welfare.component.html',
    styleUrls: ['efast-filter-welfare.component.css'],
    standalone: false
})

export class EfastFilterFilterWelfareComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title = this.cacheService.getLabelFromResource('FILTER:FILTERWelfareTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().WELFARE;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl1'),
            this.staticsService.getPlanCodeFilter().CODE_TYPE_WELFARE, false))
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl2'),
            this.staticsService.getPlanCodeFilter().CODE_4A));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl3'),
            this.staticsService.getPlanCodeFilter().CODE_4B));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl4'),
            this.staticsService.getPlanCodeFilter().CODE_4C));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl5'),
            this.staticsService.getPlanCodeFilter().CODE_4D));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl6'),
            this.staticsService.getPlanCodeFilter().CODE_4E));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl7'),
            this.staticsService.getPlanCodeFilter().CODE_4F));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl8'),
            this.staticsService.getPlanCodeFilter().CODE_4G));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl9'),
            this.staticsService.getPlanCodeFilter().CODE_4H));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl10'),
            this.staticsService.getPlanCodeFilter().CODE_4I));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl11'),
            this.staticsService.getPlanCodeFilter().CODE_4J));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl12'),
            this.staticsService.getPlanCodeFilter().CODE_4K));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl13'),
            this.staticsService.getPlanCodeFilter().CODE_4L));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl14'),
            this.staticsService.getPlanCodeFilter().CODE_4P));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl15'),
            this.staticsService.getPlanCodeFilter().CODE_4Q));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl16'),
            this.staticsService.getPlanCodeFilter().CODE_4R));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl17'),
            this.staticsService.getPlanCodeFilter().CODE_4S));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl18'),
            this.staticsService.getPlanCodeFilter().CODE_4T));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERWelfareLbl19'),
            this.staticsService.getPlanCodeFilter().CODE_4U));

        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {

        this.setBucket(this.applicationService.getAfsForm().facets.plancode.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {

        super.rowClick(filterValue);

        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().PLAN_CODE, this.queryValue, true)
    }
}